<template>
  <div class="container">
    <p>Terms And Conditions!</p>
    <ol>
      <li>Only Accept The Order If You Are Sure You Can Deliver It.</li>
      <li>You Cannot Cancel An Order That Has Been Accepted.</li>
      <li>
        Please Deliver The Order In The Stipulated Time Else You May Face A
        Penalty.
      </li>
      <li>
        The Penalty Mentioned May Vary From Not Receiving Your Reward To A Ban
        From Our App.
      </li>
      <li>
        You May Be Banned From Using Our Service If You Do Not Follow The Above
        Mentioned Rules.
      </li>
    </ol>
    <div class="link-to-dashboard"></div>
    <a class="link-to-dashboard" @click="$router.go(-1)"
      ><Arrow class="arrow" /> Back</a
    >
  </div>
</template>

<script>
import Arrow from "../assets/Icons/arrow-right-light.svg";

export default {
  name: "SaviourTermsAndConditions",
  components: {
    Arrow,
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100vw;

  p {
    font-size: 36px;
    text-align: center;
    margin: 10px 0;
  }

  h1 {
    margin: 10px 0;
    text-align: center;
  }

  ol {
    padding-left: 30px;
    text-align: left;
  }

  .link-to-dashboard {
    padding-left: 15px;
    text-transform: none;
    //text-decoration: none;
    margin-top: 20px;
    text-align: center;
    color: #000;

    .arrow {
      width: 10px;
      transform: rotate(180deg);
    }

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
